export const scheduleTabMeta = {
  id: "schedule",
  label: "Thời khóa biểu",
  shortLabel: "TKB",
};
